import Phaser from 'phaser';
import { SFX } from './AudioKeys';

export type LoadedSound = { key: string; urls: string[] };

/**
 * Build a static list of sound definitions mapped to URL(s) under the public/ directory.
 * By convention, public/ is the web root; therefore audio files live at "/audio/...".
 *
 * Minimal registration: only include files that currently exist in public/audio to avoid decode errors.
 * Add new entries as you add real assets.
 */
export function getAllSoundDefinitions(): LoadedSound[] {
  const audioBase = '/audio';

  // Currently present in the repo:
  // - public/audio/sfx/shoot.mp3
  // - public/audio/sfx/pickupGun.mp3
  // - public/audio/sfx/zombieHitByGunShot.mp3
  // Keep this minimal to prevent "Unable to decode audio data" for missing files.
  const defs: LoadedSound[] = [
    {
      key: SFX.Shoot,
      urls: [
        `${audioBase}/sfx/shoot.mp3`,
      ],
    },
    {
      key: SFX.Pickup,
      urls: [
        `${audioBase}/sfx/pickupGun.mp3`,
      ],
    },
    {
      key: SFX.EnemyHit,
      urls: [
        `${audioBase}/sfx/zombieHitByGunShot.mp3`,
      ],
    },
  ];

  return defs;
}

/**
 * Registers all sounds with Phaser's loader.
 * Keep the list minimal to only existing assets to prevent decode errors.
 */
export function preloadAllSounds(load: Phaser.Loader.LoaderPlugin): void {
  const defs = getAllSoundDefinitions();
  defs.forEach(({ key, urls }) => {
    load.audio(key, urls);
  });
}